var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "linkAppModal",
    attrs: { id: "link-applications-modal", "modal-dialog-scrollable": false },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("div", [
              _c("h5", { staticClass: "bold" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("client-profile.actions.linkApplication")) +
                    "\n      "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "font-weight-normal" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$t(
                        "client-profile.messages.linkExistingApplicationToClient"
                      )
                    ) +
                    "\n      "
                ),
              ]),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("div", { staticClass: "row align-items-center mb-3" }, [
              _c("div", { staticClass: "col-4" }, [
                _c("p", { staticClass: "small m-0" }, [
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.$t(
                          "client-profile.messages.clientProfileCurrentlyAssignedTo"
                        )
                      ) +
                      ":\n        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "col-8 d-flex flex-row align-items-center" },
                [
                  _c(
                    "profile-avatar",
                    _vm._b(
                      {
                        staticClass: "client-avatar mr-2",
                        staticStyle: { width: "2rem", height: "2rem" },
                      },
                      "profile-avatar",
                      Object.assign({}, _vm.owner),
                      false
                    )
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "bold m-0" }, [
                    _vm._v(
                      _vm._s(_vm.owner.givenName) +
                        " " +
                        _vm._s(_vm.owner.familyName)
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-4" }, [
                _c("p", { staticClass: "small m-0" }, [
                  _vm._v(
                    _vm._s(_vm.$t("client-profile.messages.linkTo")) + ":"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "col-8 col-lg-7",
                  attrs: { id: "link-app-select-container" },
                },
                [
                  _c("select2", {
                    ref: "linkAppSelect",
                    attrs: {
                      id: "link-app-select",
                      name: "link-app-select",
                      value: _vm.clientSelected,
                      options: _vm.options,
                    },
                    on: { change: _vm.handleSelect },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "d-none",
                      attrs: { for: "link-app-select" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("client-profile.messages.searchAClient"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "button",
              {
                staticClass: "btn btn-primary btn-sm",
                class: { disabled: !_vm.clientSelected },
                attrs: { type: "button" },
                on: { click: _vm.linkApplication },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("client-profile.actions.linkApplication")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }